var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncrementArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.44491 0.292212L0.469558 5.28721C0.0694414 5.80349 0.430837 6.57791 1.08909 6.57791H2.41851C2.84444 6.57791 3.21874 6.86186 3.21874 7.28779L3.21874 15.2256C3.21874 15.6515 3.52851 16 3.96735 16H6.05828C6.4713 16 6.8327 15.6515 6.8327 15.2256L6.8327 7.28779C6.8327 6.86186 7.16841 6.57791 7.59421 6.57791H8.92362C9.56897 6.57791 9.93037 5.80349 9.53025 5.30012L5.65816 0.318026C5.3613 -0.0949974 4.75467 -0.107904 4.44491 0.292212Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrementArrow);
export default __webpack_public_path__ + "static/media/increment-arrow.01372592.svg";
export { ForwardRef as ReactComponent };